import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as VatReturnsReceivedService from '../../../services/api/vatreturn_received';
import * as NotificationService from '../../../services/api/notification';
import * as RequestInformation from '../../../services/api/info_request';

class FetchVatReturnsReceivedList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_VAT_RETURN_RECEIVED_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_VAT_RETURN_RECEIVED_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_VAT_RETURN_RECEIVED_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(
    payload: VatReturnsReceivedService.FetchVatReturnsReceivedListInput
  ): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await VatReturnsReceivedService.fetchVatReturnsReceivedList(payload);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetcReminderList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchUnreadNotificationCount implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Failed,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await NotificationService.fetchUnreadNotificationCount();
        dispatch(this.onSuccess(response.data.total));
      } catch (error: any) {
        // console.log('FetchUnreadNotificationCount Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class ClearUnreadNotificationCount implements IActionMethods {
  onFailed(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onPending(result?: any): IAction {
    throw new Error('Method not implemented.');
  }
  onSuccess(): IAction {
    return {
      type: Types.SET_UNREAD_NOTIFICATION_COUNT,
      status: StateStatus.Success,
      data: 0,
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      dispatch(this.onSuccess());
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        // console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchPaymentReceivedDetailList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_DETAIL_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_DETAIL_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_PAYMENT_RECEIVED_DETAIL_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(
    payload: VatReturnsReceivedService.FetchPaymentReceivedDetailListInput
  ): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response =
          await VatReturnsReceivedService.fetchPaymentReceivedDetailList(
            payload
          );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchPaymentReceivedDetailList Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchVatReturnsReceivedListAction: (
    payload: VatReturnsReceivedService.FetchVatReturnsReceivedListInput
  ) => new FetchVatReturnsReceivedList().action(payload),
  fetchUnreadNotificationCountAction: () =>
    new FetchUnreadNotificationCount().action(),
  clearUnreadNotificationCountAction: () =>
    new ClearUnreadNotificationCount().action(),
  fetchPaymentReceivedDetailListAction: (
    payload: VatReturnsReceivedService.FetchPaymentReceivedDetailListInput
  ) => new FetchPaymentReceivedDetailList().action(payload),
};
